var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgBulletlist = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 284,
    height: 284,
    viewBox: "0 0 284 284",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.5 105C88 105 93.2 99.8 93.2 93.3C93.2 86.8 88 81.6 81.5 81.6C75 81.6 69.8 86.8 69.8 93.3C69.7 99.7 75 105 81.5 105ZM116.6 93.3C116.6 89.4 119.7 86.3 123.6 86.3H212.7C216.6 86.3 219.7 89.4 219.7 93.3C219.7 97.2 216.6 100.3 212.7 100.3H123.6C119.8 100.3 116.6 97.1 116.6 93.3ZM123.6 133.1C119.7 133.1 116.6 136.2 116.6 140.1C116.6 144 119.7 147.1 123.6 147.1H212.7C216.6 147.1 219.7 144 219.7 140.1C219.7 136.2 216.6 133.1 212.7 133.1H123.6ZM123.6 180C119.7 180 116.6 183.1 116.6 187C116.6 190.9 119.7 194 123.6 194H212.7C216.6 194 219.7 190.9 219.7 187C219.7 183.1 216.6 180 212.7 180H123.6ZM93.2 140.1C93.2 146.6 88 151.8 81.5 151.8C75 151.8 69.8 146.6 69.8 140.1C69.8 133.6 75 128.4 81.5 128.4C87.9 128.4 93.2 133.7 93.2 140.1ZM81.5 198.7C88 198.7 93.2 193.5 93.2 187C93.2 180.5 88 175.3 81.5 175.3C75 175.3 69.8 180.5 69.8 187C69.7 193.5 75 198.7 81.5 198.7Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBulletlist, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bulletlist.6e9a496d.svg";
export { ForwardRef as ReactComponent };